import { network } from 'services/network';

export const getRowTypeOptions = () => {
    const url = 'api/bo/getRowTypeOptions';
    return network.get(url).then((response) => response.data);
};
